import { object, string, number } from 'yup';

const missingInfoLinkedLoanFormSchema = object({
  loanType: string().required('* Required'),
  interestRate: number().min(2).max(8).required('* Required'),
  repaymentPlan: string().required('* Required'),
});

export default missingInfoLinkedLoanFormSchema;
